import React, {
  createContext,
  useCallback,
  useContext,
  useState,
  PropsWithChildren,
} from "react"
import native from "../native/native"

interface State {
  canToggleUltimate: boolean
  didToggleUltimate: boolean
  isUltimate: boolean
  showWarmup: boolean
}

interface Actions {
  toggleUltimate: () => void
  hideWarmup: () => void
}

interface ExpirationContextType {
  state: State
  actions: Actions
}

const ExpirationContext = createContext<ExpirationContextType | null>(null)

const ExpirationProvider = ({ children }: PropsWithChildren<{}>) => {
  const canToggleUltimate = true

  const [didToggleUltimate, setDidToggleUltimate] = useState(false)
  const [showWarmup, setShowWarmup] = useState(true)

  const toggleUltimate = useCallback(() => {
    setDidToggleUltimate((prev) => !prev)
  }, [])

  const hideWarmup = useCallback(() => {
    native.logMixpanelEvent("html_expiration_warmup_close")
    setShowWarmup(false)
  }, [])

  const isUltimate = didToggleUltimate || !canToggleUltimate

  const value: ExpirationContextType = {
    state: { canToggleUltimate, didToggleUltimate, isUltimate, showWarmup },
    actions: { toggleUltimate, hideWarmup },
  }

  return (
    <ExpirationContext.Provider value={value}>
      {children}
    </ExpirationContext.Provider>
  )
}

const useExpiration = () => {
  const ctx = useContext(ExpirationContext)
  if (!ctx)
    throw new Error("useExpiration must be used within <ExpirationProvider>")
  return ctx
}

export { ExpirationProvider, useExpiration, ExpirationContext }
